<template>
  <TheGreyWrapper v-if="opportunity">
    <TheHeader
      :center-title="opportunity.data.attributes.name"
      class="mb-20"
      back-route=".."
      force-sm-style
    />
    <form @submit.prevent="goToValidation">
      <BaseBigNumberInput
        v-model="wishAmount"
        :bottom-text="$t('Investment wish')"
        class="mb-20"
      />
      <BaseSection>
        <BaseButton
          :title="$t('Confirm my wish')"
          theme="black"
          class="mb-5 md:mb-12"
        />
      </BaseSection>
    </form>
  </TheGreyWrapper>
</template>

<script>
import loadOpportunity from '../mixins/loadOpportunity';
import { STORE_WISH } from '../store/mutation-types';
import TheHeader from '../components/TheHeader.vue';
import BaseBigNumberInput from '../components/BaseBigNumberInput.vue';
import BaseButton from '../components/BaseButton.vue';
import BaseSection from '../components/BaseSection.vue';
import TheGreyWrapper from '../components/TheGreyWrapper.vue';
import { SUBMITTED_WISH_AMOUNT } from '../analytics';

export default {
  name: 'WishForm',
  components: {
    TheHeader,
    BaseBigNumberInput,
    BaseButton,
    BaseSection,
    TheGreyWrapper,
  },
  mixins: [loadOpportunity],
  computed: {
    wishAmount: {
      set(value) {
        this.$store.commit(`opportunity/${STORE_WISH}`, value);
      },
      get() {
        return this.$store.state.opportunity.wishAmount;
      },
    },
  },
  methods: {
    goToValidation() {
      analytics.track(SUBMITTED_WISH_AMOUNT, {
        amount: this.wishAmount,
      });
      this.$router.push('validation');
    },
  },
};
</script>
